import React from "react";
import { IProduto } from "shared/interfaces/IProduto";
import { ProdutoCard } from "../modal/ProdutoCard";
import styles from "./Produtos.module.scss";

interface ProdutosProps {
  produtos: IProduto[];
  mostrarCarrinho?: boolean;
  titulo?: string;
  subtitulo?: string;
}

export const Produtos: React.FC<ProdutosProps> = ({
  produtos,
  mostrarCarrinho = true,
  titulo,
  subtitulo,
}) => {
  if (!produtos || produtos.length === 0) {
    return (
      <p className={styles.semProdutos}>
        Nenhum produto encontrado.
      </p>
    );
  }

  return (
    <div className={styles.wrapper}>
      {(titulo || subtitulo) && (
        <div className={styles.header}>
          <div>
            {titulo && (
              <h2 className={styles.titulo}>
                {titulo}
              </h2>
            )}

            {subtitulo && (
              <p className={styles.subtitulo}>
                {subtitulo}
              </p>
            )}
          </div>

          <span className={styles.quantidade}>
            {produtos.length}
          </span>
        </div>
      )}

      <section className={styles.container}>
        {produtos.map((produto) => (
          <div
            key={produto.id}
            className={styles.produtoColumn}
          >
            <ProdutoCard
              produto={produto}
              mostrarCarrinho={mostrarCarrinho}
              variant="default"
            />
          </div>
        ))}
      </section>
    </div>
  );
};